module.exports = __webpack_public_path__ + "static/media/carteBancaires.21e75af5.jpg";